import React from 'react'
import moment from 'moment'
import styled from 'styled-components'
import { CalendarIcon } from './EventDetailView.style'

const LoudSpeakerIcon = ({ color = '#FFFFFF', width = 11, height = 11 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      d='M0.14 5.34H5.37L11.29 0.28V19.73L5.37 14.67H0.14V5.34Z'
      fill={color}
    />
    <path
      d='M13.88 2.24C16.39 2.24 19.08 5.61 19.08 10C19.08 14.4 16.42 17.97 13.9 17.97'
      stroke={color}
      strokeWidth='1.13'
      strokeLinecap='butt'
      fill='none'
    />
    <path
      d='M13.24 5.59C14.46 5.6 15.77 7.57 15.77 10.01C15.76 12.44 14.45 14.41 13.24 14.41'
      stroke={color}
      strokeWidth='0.935'
      strokeLinecap='butt'
      fill='none'
    />
  </svg>
)

const Badge = styled.div`
  font-family: 'Proxima-Nova';
  font-size: 10px;
  font-weight: 600;
  line-height: 115%;
  text-transform: uppercase;
  padding: 3px 8px;
  display: inline-flex;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 16px;

  ${({ variant = 'default' }) => {
    const styles = {
      default: `
        color: #3c4b37;
        border: 0.667px solid #758e6d;
        background: #d8e1d5;
      `,
      sold: `
        color: #3b3b3b;
        border: 0.667px solid #636363;
        background: #e1e1e1;
      `,
      fillingFast: `
        color: #826646;
        border: 0.667px solid #826646;
        background: #f1e8dd;
      `,
      waitlisted: `
        color: #740031;
        border: 0.667px solid #740031;
        background: #FFEBEE;
      `,
      registered: `
        color: #fff;
        border: 0.667px solid #758e6d;
        background: #000;
      `
    }

    return styles[variant]
  }}
`

export const EventStatusBadge = ({
  usedSlots = 0,
  maxSlots = 0,
  salesEnd,
  salesStart,
  registrationStatus = '',
  ...props
}) => {
  const now = moment()

  const slots = Number(maxSlots)
  const used = Number(usedSlots)

  const remainingSlots = slots - used
  const percentageLeft = slots > 0 ? (remainingSlots / slots) * 100 : 100

  if (registrationStatus === 'waitlisted') {
    return (
      <Badge variant='waitlisted' {...props}>
        ● on waitlist
      </Badge>
    )
  }
  if (registrationStatus === 'registered') {
    return (
      <Badge variant='registered' {...props}>
        <CalendarIcon
          color='white'
          style={{
            width: '11px',
            height: '11px',
            paddingBottom: '1px'
          }}
        />
        You’re Registered
      </Badge>
    )
  }

  if (salesStart && now.isBefore(moment(salesStart))) {
    return (
      <Badge variant='registered' {...props}>
        <LoudSpeakerIcon />
        Registration begins on{' '}
        {moment(salesStart).format('ddd, MMMM D hh:mm A')}
      </Badge>
    )
  }

  if (salesEnd && now.isAfter(moment(salesEnd))) {
    return (
      <Badge variant='sold' {...props}>
        ● Registration Closed
      </Badge>
    )
  }

  if (slots > 0) {
    if (remainingSlots <= 0) {
      return (
        <Badge variant='sold' {...props}>
          ● Sold Out
        </Badge>
      )
    }

    if (percentageLeft <= 25) {
      return (
        <Badge variant='fillingFast' {...props}>
          ● Filling Fast
        </Badge>
      )
    }
  }

  return <Badge {...props}>● Spots Available</Badge>
}
